export default "__VITE_ASSET__XIiVfB_K__"